import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import {
    CssBaseline,
    ThemeProvider
} from "@material-ui/core";
import {SnackbarProvider} from "notistack";

import * as serviceWorker from "./serviceWorker";

import App from "./views/App";

import store from "./store";
import theme from "./theme";


ReactDOM.render(
    <Provider store={store.getStore()}>
        <ThemeProvider theme={theme}>
            <CssBaseline />

            <SnackbarProvider maxSnack={3}>
                <Router>
                    <App />
                </Router>
            </SnackbarProvider>
        </ThemeProvider>
    </Provider>,
    document.getElementById("root")
);

serviceWorker.unregister();
